<template>
  <div
    class="modal edit-modal"
    :class="{ 'is-active': isActive }">

    <div class="modal-background"></div>

    <div
      class="modal-content"
      :class="{ 'is-wide': wide }">

      <article class="message is-info">
        <div class="message-header">
          <p>{{ caption }}</p>
        </div>

        <div class="message-body">
          <slot></slot>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: 'Item bewerken'
    },
    wide: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  h2 {
    background:
  }

  .modal-content {
    min-height: 25%;
  }

  #combinatorWrapper .modal-content {
    min-height: 80vh;
  }

  .modal-content.is-wide {
    width: 95%;
  }

  .message {
    border-radius: 6px;
    min-height: 100%;
  }
</style>
